import NumbersBody from './NumbersBody';

const View = (props) => <NumbersBody {...props} />;

export default View;
